import { Box } from "@mui/material";
import { keyframes } from "@mui/system";
import { useEffect, useState } from "react";
import { stepCancelProps } from "../../../../types/common";
import styles from "./styles";
import { useAppSelector } from "../../../../redux/store";

const PaymentRedirect = (props: stepCancelProps) => {
  const [time, setTime] = useState("2s");
  const [timer, setTimer] = useState(2);
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText } = customerJourney;

  const fillProgress = keyframes`
  from { width: 0%; }
  to { width: 100%; }
`;

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimer((prevTime) => {
        return prevTime >= 1 ? prevTime - 1 : 0;
      });
    }, 1000);
    return () => {
      clearInterval(timerInterval);
    };
  }, []);

  return (
    <Box sx={styles.wrapper}>
      <Box className="redirect_text">
        {pageText?.textMetadata?.redirectingtohomepage}
      </Box>
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#DFDFDF",
          height: "8px",
          border: "1px solid #ccc",
          borderRadius: "100px",
          marginTop: "20px",
          ".progressBar": {
            height: "8px",
            backgroundColor: "#005CB9",
            borderRadius: "100px",
            animation: `${fillProgress} ${time} linear forwards`, // Reference the keyframes animation
          },
        }}
      >
        <Box className="progressBar" />
      </Box>
    </Box>
  );
};

export default PaymentRedirect;
